import React from "react";
import leaders from "../../src/data/leaders.json";
import styles from "../styles/leader-cards.module.css";

function LeaderCards() {
  // Group leaders by section
  const groupedLeaders = leaders.reduce((acc, leader) => {
    if (!acc[leader.section]) acc[leader.section] = [];
    acc[leader.section].push(leader);
    return acc;
  }, {});

  return (
    <section className={styles.whosWho} id="leaders">
      <h2>Who's Who</h2>

      {Object.keys(groupedLeaders).map((section) => (
        <div key={section} className={styles.leaderSection}>
          <h3 className={styles.sectionTitle}>{section}</h3>
          <div className={styles.leaderList}>
            {groupedLeaders[section].map((leader) => (
              <div className={styles.leaderCard} key={leader.name}>
                <img src={`${process.env.PUBLIC_URL}/images/${leader.photo}`} alt={leader.name} />
                <h4>{leader.name}</h4>
                <p>Role: {leader.role}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}

export default LeaderCards;